import { readItemAuthoringData } from '../janus-engine/authoring/item-save-validation';
import { validateItemAuthoring } from '../janus-engine/authoring/publish-validation';

type LayerReply = {
    ok: boolean;
    item_id: string;
    revision_token: string;
    authored_payload?: Record<string, unknown> | null;
    warnings?: { message: string }[];
};

/** Called only after success/revision adoption. Audit findings never decide a layer mutation. */
export function itemLayerAudit(table: HTMLTableElement, reply: LayerReply): void {
    if (!reply.ok || !table.isConnected || reply.item_id !== table.dataset.itemId
        || reply.revision_token !== table.dataset.revisionToken) return;
    const output = table.querySelector<HTMLElement>('[data-layer-audit]');
    if (!output) return;
    const messages = (reply.warnings ?? []).map(warning => warning.message);
    try {
        if (!reply.authored_payload) throw new Error('Missing saved state');
        const island = document.getElementById(table.dataset.auditData ?? '');
        const facts = readItemAuthoringData(island?.textContent ?? 'null');
        messages.push(...validateItemAuthoring(reply.authored_payload, facts, 'audit').warnings.map(finding => finding.message));
    } catch {
        messages.push('Saved; authoring audit unavailable. Reload to inspect.');
    }
    output.replaceChildren();
    for (const message of messages) {
        const p = document.createElement('p');
        p.className = 'small text-warning-emphasis mb-0';
        p.textContent = message;
        output.appendChild(p);
    }
}

declare global { interface Window { ftItemLayerAudit: typeof itemLayerAudit } }
window.ftItemLayerAudit = itemLayerAudit;
